"use client";

import React, { useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { useLazyGetStartupListQuery } from "@/store";
import { ChevronDoubleRightIcon } from "@heroicons/react/20/solid";
import { StartUpCard } from "./StartUpCard";

export function StartUpHomePage() {
  const [getStartupList, { data, isLoading }] = useLazyGetStartupListQuery();
  const getStartup = async () => {
    await getStartupList();
  };

  const t = useTranslations();

  const [randomPosts, setRandomPosts] = useState([]);

  useEffect(() => {
    getStartup();
    if (data?.body?.data) {
      const shuffledPosts = shuffleArray(data?.body?.data || []);
      const randomThreePosts = shuffledPosts.slice(0, 3);
      setRandomPosts(randomThreePosts);
    }
  }, [data?.body?.data]);

  const shuffleArray = (array) => {
    const shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [
        shuffledArray[j],
        shuffledArray[i],
      ];
    }
    return shuffledArray;
  };

  return (
    <section className="StartUpHomePage mx-auto bg-[#f5f5f5]">
      <div>
        <div className="bg-white lg:mt-20 sm:mt-12 mt-6 lg:mb-20 mb-12">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-0 justify-between">
              <div className="text-start">
                <h2 className="sm:text-[22px] sm:leading-[44px] tracking-[0.1px] text-mainDarkPurpleText md:text-[42px] mb-2 font-bold ">
                  {t("startUp_header")}
                </h2>
                <p className="md:text-xl sm:text-base text-sm sm:tracking-[0.1px] sm:font-normal text-mainLightPurpleText  ">
                  {t("startUp_learn")}
                </p>
              </div>
              <div className="">
                <Link href={"/startups"}>
                  <button
                    type="button"
                    className="lsm:px-6 px-2 py-[10px] text-white bg-mainLightPurple hover:bg-mainLightPurpleHover active:bg-mainLightPurpleActive text-center rounded-[8px] btnLspace font-semibold text-base "
                  >
                    <span className=" flex flex-row flex-nowrap items-center gap-2">
                      {t("startUp_all")} 
                      <ChevronDoubleRightIcon className='w-4 h-4 mt-[4px]' />
                    </span>

                  </button>
                </Link>
              </div>
            </div>
            <div className="mx-auto mt-16 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
              {randomPosts.map((post) => (
                <StartUpCard key={post.id} post={post} />
              ))}
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
}

